// import React, { useState } from 'react';
// import book_nanny from '../../assets/img/book_nanny.svg';
// import WhatsApp_icon from '../../assets/img/WhatsApp_icon.png.webp';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import { BASE_URL } from '../../utils/Constants';

// const Contact = () => {
//     const phoneNumber = "+34617243659";
//     const message = "Hello! I'm interested in your services.";

//     const [bookingData, setBookingData] = useState({
//         firstname: '',
//         lastname: '',
//         email: '',
//         description: ''
//     });

//     const [nannyData, setNannyData] = useState({
//         firstname: '',
//         lastname: '',
//         email: '',
//         address: '',
//         experience: '',
//         description: ''
//     });

//     const handleClick = () => {
//         const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
//         window.open(whatsappURL, "_blank");
//     }

//     // Handle changes for booking form
//     const handleBookingChange = (e) => {
//         setBookingData({
//             ...bookingData,
//             [e.target.id]: e.target.value
//         });
//     }

//     // Handle changes for nanny form
//     const handleNannyChange = (e) => {
//         setNannyData({
//             ...nannyData,
//             [e.target.id]: e.target.value
//         });
//     }

//     // Common submit handler
//     const handleSubmit = async (e, type) => {
//         e.preventDefault();
//         let payload = { type };

//         if (type === 'booking') {
//             payload = {
//                 ...payload,
//                 firstname: bookingData.firstname,
//                 lastname: bookingData.lastname,
//                 email: bookingData.email,
//                 description: bookingData.description
//             };
//         } else if (type === 'nanny') {
//             payload = {
//                 ...payload,
//                 firstname: nannyData.firstname,
//                 lastname: nannyData.lastname,
//                 email: nannyData.email,
//                 address: nannyData.address,
//                 experience: nannyData.experience,
//                 description: nannyData.description
//             };
//         }

//         try {
//             await axios.post(`${BASE_URL}/v1/contact-us`, payload);
//             alert('Submitted successfully!');
//         } catch (error) {
//             console.error('Submission error:', error);
//             alert('Failed to submit!');
//         }
//     }

//     return (
//         <>
//             <div className="inner_pages_banner position-absolute top-0 start-0 pb-0"></div>
//             <div className="baner_text about_nanny_texts d-flex tutoring_inner_sec pb-0 sections_padding pt-0 align-items-center text-center">
//                 <div className="container">
//                     <h1 className='contact_texts'>Contact Us</h1>
//                 </div>
//             </div>
//             <div className="sections_padding mt-5 pt-2">
//                 <div className="container">
//                     <h1 className="mb-4 pb-3 text-center"><span className="position-relative">Book a Nanny</span></h1>
//                     <p className="text-center">During all of our services we aim to provide the best possible service to our customers</p>
//                     <div className="row mt-3 mt-md-5">
//                         <div className="col-md-10 offset-md-1 booking_box">
//                             <div className="row align-items-center">
//                                 <div className="col-md-6">
//                                     <div className="px-3 pt-md-0 pt-5">
//                                         <img className="w-100" src={book_nanny} alt="logo" />
//                                     </div>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <form className="py-5 px-4" onSubmit={(e) => handleSubmit(e, 'booking')}>
//                                         <div className="mb-3">
//                                             <label htmlFor="firstname" className="form-label">First Name</label>
//                                             <input type="text" className="form-control" id="firstname" placeholder="First Name" value={bookingData.firstname} onChange={handleBookingChange} />
//                                         </div>
//                                         <div className="mb-3">
//                                             <label htmlFor="lastname" className="form-label">Last Name</label>
//                                             <input type="text" className="form-control" id="lastname" placeholder="Last Name" value={bookingData.lastname} onChange={handleBookingChange} />
//                                         </div>
//                                         <div className="mb-3">
//                                             <label htmlFor="email" className="form-label">Email</label>
//                                             <input type="email" className="form-control" id="email" placeholder="Email" value={bookingData.email} onChange={handleBookingChange} />
//                                         </div>
//                                         <div className="mb-3">
//                                             <label htmlFor="description" className="form-label">Description</label>
//                                             <textarea className="form-control" id="description" rows="3" value={bookingData.description} onChange={handleBookingChange}></textarea>
//                                         </div>
//                                         <button type="submit" className="btn btn-primary d-inline-block mt-4 all_btns px-4 py-2 position-relative">Submit</button>
//                                     </form>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="sections_padding secondry_bg">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-md-4 h-100 service_text contact_bg pe-0">
//                             <div className="p-3 p-xl-5 contact_bg_color">
//                                 <h2 className="mb-4 fw-700 touch_text">Get In Touch</h2>
//                                 <ul>
//                                     <li className="address_box d-flex align-items-center mb-3 mb-xl-5">
//                                         <Link onClick={handleClick} target='_blank'><i className="fa fa-user d-flex align-items-center justify-content-center me-2 me-lg-3"><img src={WhatsApp_icon} alt='WhatsApp_icon' style={{ width: 50, height: 50 }} /></i></Link>
//                                         <div className="address_info">
//                                             <h6 className="fw-700 mb-2">+34617243659</h6>
//                                             <h6 className="fw-700 mb-2"> info@nanny-line.com</h6>
//                                         </div>
//                                     </li>
//                                 </ul>
//                             </div>
//                         </div>
//                         <div className="col-md-8 ps-3 ps-sm-0">
//                             <div className="py-3 py-md-5 w-100">
//                                 <div className="iframe_container">
//                                     <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d2434231.135558439!2d-3.7037902!3d40.4167754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1685378413776!5m2!1sen!2sin" scrolling="no" frameBorder="0"
//                                         allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" style={{ position: "relative; height: 100%; width: 100%;" }}>
//                                     </iframe>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="sections_padding">
//                 <div className="container">
//                     <h1 className="mb-4 pb-3 text-center"><span className="position-relative">Apply As Nanny</span></h1>
//                     <p className="text-center">During all of our services we aim to provide the best possible service to our customers</p>
//                     <div className="row mt-3 mt-md-5">
//                         <div className="col-md-10 offset-md-1">
//                             <div className="row align-items-center">
//                                 <div className="col-md-6">
//                                     <h4 className="mb-3">Welcome at The Nanny Line!</h4>
//                                     <p>We are place nannies with families from all over the world at home, in their hotels or events. We have many different services for any type of schedule. Part time, full time or occasional according to your free time. We currently work in Barcelona, Ibiza and Madrid. Apply through the contact form or send us an email with your CV and motivation letter: info@nanny-line.com
//                                     </p>
//                                     <h4 className=" mt-3 mt-md-5 mb-3">Our requirements are:</h4>
//                                     <ul>
//                                         <li className="mb-2">- 3 years of professional child care experience
//                                         </li>
//                                         <li className="mb-2">- 21+ years old
//                                         </li>
//                                         <li className="mb-2">- clear criminal record
//                                         </li>
//                                         <li className="mb-2">- at least two references
//                                         </li>
//                                     </ul>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <form className="py-5 booking_box px-4" onSubmit={(e) => handleSubmit(e, 'nanny')}>
//                                         <div className="mb-3">
//                                             <label htmlFor="firstname" className="form-label">First Name</label>
//                                             <input type="text" className="form-control" id="firstname" placeholder="First Name" value={nannyData.firstname} onChange={handleNannyChange} />
//                                         </div>
//                                         <div className="mb-3">
//                                             <label htmlFor="lastname" className="form-label">Last Name</label>
//                                             <input type="text" className="form-control" id="lastname" placeholder="Last Name" value={nannyData.lastname} onChange={handleNannyChange} />
//                                         </div>
//                                         <div className="mb-3">
//                                             <label htmlFor="nannyemail" className="form-label">Email</label>
//                                             <input type="email" className="form-control" id="email" placeholder="Email" value={nannyData.email} onChange={handleNannyChange} />
//                                         </div>
//                                         <div className="mb-3">
//                                             <label htmlFor="nannyaddress" className="form-label">Address</label>
//                                             <input type="text" className="form-control" id="address" placeholder="Address" value={nannyData.address} onChange={handleNannyChange} />
//                                         </div>
//                                         <div className="mb-3">
//                                             <label htmlFor="nannyexp" className="form-label">Years of professional experience</label>
//                                             <input type="text" className="form-control" id="experience" placeholder="Experience" value={nannyData.experience} onChange={handleNannyChange} />
//                                         </div>
//                                         <div className="mb-3">
//                                             <label htmlFor="description" className="form-label">Description</label>
//                                             <textarea className="form-control" id="description" rows="3" value={nannyData.description} onChange={handleNannyChange}></textarea>
//                                         </div>
//                                         <button type="submit" className="btn btn-primary d-inline-block mt-4 all_btns px-4 py-2 position-relative">Submit</button>
//                                     </form>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default Contact;

import React, { useState } from "react";
import book_nanny from "../../assets/img/book_nanny.svg";
import WhatsApp_icon from "../../assets/img/WhatsApp_icon.png.webp";
import { Link } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../utils/Constants";

const Contact = () => {
   const phoneNumber = "+34617243659";
    const message = "Hello! I'm interested in your services.";

    const [bookingData, setBookingData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        description: "",
    });

    const [nannyData, setNannyData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        address: "",
        experience: "",
        description: "",
    });

    // CAPTCHA states (backend driven)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [captchaQuestion, setCaptchaQuestion] = useState("");
    const [captchaId, setCaptchaId] = useState("");
    const [captchaInput, setCaptchaInput] = useState("");
    const [payloadToSubmit, setPayloadToSubmit] = useState(null);
    const [currentFormType, setCurrentFormType] = useState("");

    const handleClick = () => {
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, "_blank");
    };

    const handleBookingChange = (e) => {
        setBookingData({ ...bookingData, [e.target.id]: e.target.value });
    };

    const handleNannyChange = (e) => {
        setNannyData({ ...nannyData, [e.target.id]: e.target.value });
    };

    // 🔐 Fetch captcha from backend
    const fetchCaptcha = async () => {
        const res = await axios.get(`${BASE_URL}/v1/captcha`);
        setCaptchaQuestion(res.data.data.question);
        setCaptchaId(res.data.data.captchaId);
        setCaptchaInput("");
    };

    // Open captcha modal before submission
    const openCaptchaModal = async (type) => {
        let payload = { type };

        if (type === "booking") {
            payload = { ...payload, ...bookingData };
        } else {
            payload = { ...payload, ...nannyData };
        }

        setPayloadToSubmit(payload);
        setCurrentFormType(type);
        await fetchCaptcha();
        setIsModalOpen(true);
    };

    // Handle captcha validation and submit form
    const handleCaptchaSubmit = async () => {
        try {
            await axios.post(`${BASE_URL}/v1/contact-us`, {
                ...payloadToSubmit,
                captchaId,
                captchaAnswer: captchaInput
            });

            alert("Form submitted successfully!");

            if (currentFormType === "booking") {
                setBookingData({ firstname: "", lastname: "", email: "", description: "" });
            } else {
                setNannyData({
                    firstname: "",
                    lastname: "",
                    email: "",
                    address: "",
                    experience: "",
                    description: "",
                });
            }

            setIsModalOpen(false);
        } catch (error) {
            alert(error?.response?.data?.message || "Captcha invalid");
            fetchCaptcha();
        }
    };


    return (
        <>
            <div className="inner_pages_banner position-absolute top-0 start-0 pb-0"></div>
            <div className="baner_text about_nanny_texts d-flex tutoring_inner_sec pb-0 sections_padding pt-0 align-items-center text-center">
                <div className="container">
                    <h1 className="contact_texts">Contact Us</h1>
                </div>
            </div>

            {/* Booking Form */}
            <div className="sections_padding mt-5 pt-2">
                <div className="container">
                    <h1 className="mb-4 pb-3 text-center">
                        <span className="position-relative">Book a Nanny</span>
                    </h1>
                    <div className="row mt-3 mt-md-5">
                        <div className="col-md-10 offset-md-1 booking_box">
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    <img className="w-100" src={book_nanny} alt="logo" />
                                </div>
                                <div className="col-md-6">
                                    <form
                                        className="py-5 px-4"
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            openCaptchaModal("booking");
                                        }}
                                    >
                                        <div className="mb-3">
                                            <label htmlFor="firstname" className="form-label">
                                                First Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="firstname"
                                                value={bookingData.firstname}
                                                onChange={handleBookingChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="lastname" className="form-label">
                                                Last Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="lastname"
                                                value={bookingData.lastname}
                                                onChange={handleBookingChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="email" className="form-label">
                                                Email
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                value={bookingData.email}
                                                onChange={handleBookingChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="description" className="form-label">
                                                Description
                                            </label>
                                            <textarea
                                                className="form-control"
                                                id="description"
                                                rows="3"
                                                value={bookingData.description}
                                                onChange={handleBookingChange}
                                            ></textarea>
                                        </div>
                                        <button type="submit" className="btn btn-primary mt-4">
                                            Submit
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sections_padding secondry_bg">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 h-100 service_text contact_bg pe-0">
                            <div className="p-3 p-xl-5 contact_bg_color">
                                <h2 className="mb-4 fw-700 touch_text">Get In Touch</h2>
                                <ul>
                                    <li className="address_box d-flex align-items-center mb-3 mb-xl-5">
                                        <Link onClick={handleClick} target="_blank">
                                            <i className="fa fa-user d-flex align-items-center justify-content-center me-2 me-lg-3">
                                                <img
                                                    src={WhatsApp_icon}
                                                    alt="WhatsApp_icon"
                                                    style={{ width: 50, height: 50 }}
                                                />
                                            </i>
                                        </Link>
                                        <div className="address_info">
                                            <h6 className="fw-700 mb-2">+34617243659</h6>
                                            <h6 className="fw-700 mb-2"> info@nanny-line.com</h6>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-8 ps-3 ps-sm-0">
                            <div className="py-3 py-md-5 w-100">
                                <div className="iframe_container">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d2434231.135558439!2d-3.7037902!3d40.4167754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1685378413776!5m2!1sen!2sin"
                                        scrolling="no"
                                        frameBorder="0"
                                        allowFullScreen
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        style={{ position: "relative; height: 100%; width: 100%;" }}
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Nanny Form */}
            <div className="sections_padding">
                <div className="container">
                    <h1 className="mb-4 pb-3 text-center">
                        <span className="position-relative">Apply As Nanny</span>
                    </h1>
                    <div className="row mt-3 mt-md-5">
                        <div className="col-md-10 offset-md-1">
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    <h4 className="mb-3">Welcome at The Nanny Line!</h4>
                                    <p>
                                        We are place nannies with families from all over the world
                                        at home, in their hotels or events. We have many different
                                        services for any type of schedule. Part time, full time or
                                        occasional according to your free time. We currently work in
                                        Barcelona, Ibiza and Madrid. Apply through the contact form
                                        or send us an email with your CV and motivation letter:
                                        info@nanny-line.com
                                    </p>

                                    <h4 className=" mt-3 mt-md-5 mb-3">Our requirements are:</h4>
                                    <ul>
                                        <li className="mb-2">
                                            - 3 years of professional child care experience
                                        </li>
                                        <li className="mb-2">- 21+ years old</li>
                                        <li className="mb-2">- clear criminal record</li>
                                        <li className="mb-2">- at least two references</li>
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <form
                                        className="py-5 booking_box px-4"
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            openCaptchaModal("nanny");
                                        }}
                                    >
                                        <div className="mb-3">
                                            <label htmlFor="firstname" className="form-label">
                                                First Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="firstname"
                                                value={nannyData.firstname}
                                                onChange={handleNannyChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="lastname" className="form-label">
                                                Last Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="lastname"
                                                value={nannyData.lastname}
                                                onChange={handleNannyChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="email" className="form-label">
                                                Email
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                value={nannyData.email}
                                                onChange={handleNannyChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="address" className="form-label">
                                                Address
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="address"
                                                value={nannyData.address}
                                                onChange={handleNannyChange}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="experience" className="form-label">
                                                Experience
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="experience"
                                                value={nannyData.experience}
                                                onChange={handleNannyChange}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="description" className="form-label">
                                                Description
                                            </label>
                                            <textarea
                                                className="form-control"
                                                id="description"
                                                rows="3"
                                                value={nannyData.description}
                                                onChange={handleNannyChange}
                                            ></textarea>
                                        </div>
                                        <button type="submit" className="btn btn-primary mt-4">
                                            Submit
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CAPTCHA Modal */}
{isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content p-4 bg-white rounded shadow text-center">
                        <h6 className="mb-3">Please solve the captcha</h6>

                        <div className="d-flex justify-content-center align-items-center mb-3">
                            <strong className="me-2">{captchaQuestion}</strong>

                            <button
                                className="btn btn-light p-1"
                                onClick={fetchCaptcha}
                                title="Refresh Captcha"
                                style={{ border: "none", background: "transparent" }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    viewBox="0 0 24 24"
                                >
                                    <polyline points="23 4 23 10 17 10" />
                                    <polyline points="1 20 1 14 7 14" />
                                    <path d="M3.51 9a9 9 0 0114.13-3.36L23 10M1 14l4.36 4.36A9 9 0 0020.49 15" />
                                </svg>
                            </button>
                        </div>

                        <input
                            type="text"
                            className="form-control mb-3"
                            placeholder="Enter answer"
                            value={captchaInput}
                            onChange={(e) => setCaptchaInput(e.target.value)}
                        />

                        <div className="d-flex justify-content-between">
                            <button className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>
                                Cancel
                            </button>
                            <button className="btn btn-primary" onClick={handleCaptchaSubmit}>
                                Submit
                            </button>
                        </div>
                    </div>

                    <style>{`
                        .modal-overlay {
                            position: fixed;
                            inset: 0;
                            background: rgba(0,0,0,0.5);
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            z-index: 1000;
                        }
                        .modal-content {
                            width: 260px;
                        }
                    `}</style>
                </div>
            )}
        </>
    );
};

export default Contact;
